var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDairy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4.032c0 .635.169 1.259.489 1.807l-4.156 4.17V8.635c0-.841.295-1.655.834-2.302.538-.646.833-1.46.833-2.301V4h-.167a.333.333 0 0 1-.333-.333V3c0-.184.15-.333.333-.333h2.334c.184 0 .333.149.333.333v.667c0 .184-.15.333-.333.333H9v.032Zm-2.333 9.301A1.333 1.333 0 0 1 5.333 12v-.657l4.711-4.728c.403.594.623 1.297.623 2.02V12c0 .736-.597 1.333-1.334 1.333H6.667ZM8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm0 15a7 7 0 0 0 5.262-11.614l-3.218 3.23a3.614 3.614 0 0 0-.21-.283 3.594 3.594 0 0 1-.345-.493l3.106-3.118a7 7 0 0 0-9.857 9.892l2.595-2.605v1.334l-1.928 1.935A6.97 6.97 0 0 0 8 15Z",
    fill: "#0E111D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDairy);
export default __webpack_public_path__ + "static/media/dairy.2a70268fc26946b4e05419a31c8f9ca0.svg";
export { ForwardRef as ReactComponent };